import { AssetTypeCfg, IssueCfg, LocalizedIssueComponent, LocalizedRiskLevel } from './issue/issue.dto';
import { InspectionQuery } from './inspection/inspection.dto';
import { AssetQuery } from './asset/asset.dto';
import { ChangeTyped, DivisionQuery, Query } from '@damofire/data-commons';

export interface WarehouseSyncEvent {
  changes: ChangeTyped<any>[];
  division: string;
  store: string;
}

export interface Operation {
  _id: string;
  store: string;
  operation: OPERATION;
  division: { _id: string };
  data?: unknown;
}

export enum OPERATION {
  ADD = 'add',
  DELETE = 'delete',
  UPDATE = 'update',
}

export interface Description<T = any> {
  _id?: T;
  localized?: string;
  description?: string;
  descriptionEn?: string;
  descriptionFr?: string;
}

export interface Filter {
  channel: string;
  fieldName: string;
}

export type TypedDesQuery = DivisionQuery | InspectionQuery | AssetQuery | Query;

export const mapComponent = (c: string, cfg: AssetTypeCfg, lang: string): Description<number> => {
  const issueComponent = {
    _id: cfg.mysqlIds[c],
    description: c,
    descriptionFr: cfg.localized[`${c}_fr`],
    descriptionEn: cfg.localized[`${c}_en`],
  } as LocalizedIssueComponent;

  if (cfg.colors && cfg.colors[c]) {
    issueComponent.color = cfg.colors[c];
  }

  return translate(issueComponent, lang);
};

export const mapPriority = (p: string, cfg: IssueCfg, lang: string): LocalizedRiskLevel => {
  const issuePriority: LocalizedRiskLevel = {
    _id: cfg.mysqlIds[p],
    weight: cfg.weightedPriorities[p],
    description: p,
    descriptionFr: cfg.localized[`${p}_fr`],
    descriptionEn: cfg.localized[`${p}_en`],
  };

  if (cfg.colors && cfg.colors[p]) {
    issuePriority.color = cfg.colors[p];
  }

  return translate(issuePriority, lang);
};

export const mapDescription = (c: string, cfg: IssueCfg | AssetTypeCfg, lang: string): Description<number> => {
  const description = {
    _id: cfg.mysqlIds[c],
    description: c,
    descriptionFr: cfg.localized[`${c}_fr`],
    descriptionEn: cfg.localized[`${c}_en`],
  } as Description<number>;
  return translate(description, lang);
};

export const translate = <T>(description: Description<T>, lang: string): Description<T> => {
  description.localized = lang === 'en' ? description.descriptionEn : description.descriptionFr;
  return description;
};

export const translateAll = (descriptions: Description[], lang: string) => {
  descriptions.forEach((d) => translate(d, lang));
};
